import { Grid } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { callback } from "chart.js/dist/helpers/helpers.core";
import { title } from "process";

ChartJS.register(ArcElement, Tooltip, Legend);

type ChartData = {
  [key: string]: number;
};

type PercentageDisplay = {
  labels: string[];
  values: number[];
  colors: string[];
};

const MisDoughnutChart = ({
  totalValue,
  name,
  counts,
  percentage,
  colors,
  title,
}: {
  totalValue: any;
  name: string[];
  counts: number[];
  percentage: number[];
  colors: string[];
  title: string;
}) => {
  const labels = name;
  const values = counts;

  const PercentageDisplay = ({ labels, values, colors }: PercentageDisplay) => {
    return (
      <div className="grid grid-cols-2 2xl:gap-5 gap-2 2xl:px-10">
        {labels.map((label, index) => (
          <div key={index} className="">
            <div className="flex items-center gap-1">
              <span className="">
                <FiberManualRecordIcon
                  fontSize="small"
                  style={{ color: colors[index] }}
                />
              </span>
              <span className="text-14 font-medium text-secondary text-wrap">
                {label}
              </span>
            </div>

            {<div className="pt-2 ps-2">
              <span className="text-16 font-semibold text-primary ps-4 text-wrap">
                {values?.[index]}
              </span>
              <span className="text-16 font-semibold text-primary ps-1">
                {`(${percentage?.[index]}%)`}
              </span>
            </div>}
          </div>
        ))}
      </div>
    );
  };

  const totalValues: any = totalValue;

  const data = {
    labels: labels,
    datasets: [
      {
        label: "value",
        data: values,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
      },
    ],
  };

  const options = {
    // maintainAspectRatio: false,
    animation: false,
    // cutout: 35,
    responsive: true,
    // aspectRatio: 1,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    elements: {
      arc: {
        spacing: 0.5,
      },
    },

    plugins: {
      legend: {
        display: false,
        labels: {
          font: {
            size: 14,
            family: "Inter",
          },
        },
      },

      tooltip: {
        enabled: true,
        position: "nearest" as "nearest",
        backgroundColor: "#FFFFFF",
        titleColor: "#101828",
        titleFont: {
          size: 14,
          weight: 600 as const,
          family: "Inter",
        },
        bodyColor: "#101828",
        boxPadding: 4,
        bodyFont: {
          size: 12,
          weight: 500 as const,
          family: "Inter",
        },
        padding: 10,
        cornerRadius: 6,
        borderColor: "#EAECF0",
        borderWidth: 2,
        callbacks: {
          label: function (context: any) {
            const label = context?.label;
            const value = context.formattedValue;
            return `${label}: ${value}`;
          },
          title: function (context: any) {
            return title;
          },
        },
      },
    },
  };

  const textCenter = {
    id: "textCenter",
    beforeDatasetsDraw(chart: any, args: any, pluginOptions: any) {
      const { ctx, data } = chart;
      ctx.save();
      ctx.font = "bolder 24px Inter";
      ctx.fillStyle = "#101828";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(
        totalValues,
        chart.getDatasetMeta(0).data[0]?.x,
        chart.getDatasetMeta(0).data[0]?.y
      );
    },
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ display: "flex", alignItems: "center", minHeight: "100%", minWidth: "100%" }}
      >
        <Grid item xs={12} sm={4} md={4} sx={{ minWidth: "153px", height: "100%" }}>
          <Doughnut data={data} options={options} plugins={[textCenter]} />
        </Grid>
        <Grid item xs={12} sm={8} md={8} sx={{ minWidth: "153px", }}>
          <PercentageDisplay labels={labels} values={values} colors={colors} />
        </Grid>
      </Grid>
    </>
  );
};
export default MisDoughnutChart;
